<form id="parkerReplaceSubscriptionForm" [formGroup]="parkerSubscriptionForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label required">{{'i18n.domain.parker-administration.overview.function-dialog.function-form.replace-subscription.old-subscription' | translate}}</label>
      <ejs-dropdownlist id="oldSubscription"
                        [dataSource]="oldSubscriptionsDropdownValues"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        formControlName="oldSubscriptionId"></ejs-dropdownlist>
      <app-error-messages [control]="parkerSubscriptionForm.controls.oldSubscriptionId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label required">{{'i18n.domain.parker-administration.overview.function-dialog.function-form.replace-subscription.new-subscription' | translate}}</label>
      <ejs-dropdownlist id="newSubscription"
                        [dataSource]="newSubscriptionsDropdownValues"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        formControlName="newSubscriptionId"></ejs-dropdownlist>
      <app-error-messages [control]="parkerSubscriptionForm.controls.newSubscriptionId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12 check-box-row">
      <ejs-checkbox label="{{ 'i18n.domain.parker-administration.overview.function-dialog.function-form.replace-subscription.recalc-sessions' | translate }}" formControlName="doRecalcSessions" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="d-block">{{'i18n.domain.parker-administration.detail.form.fromDateImmediate' | translate}}</label>
      <app-yes-no-group-button id="isFromDateImmediate"
                               [(ngModel)]="isFromDateImmediate"
                               (change)="fromDateImmediateChanged()"
                               [ngModelOptions]="{standalone: true}"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label" [ngClass]="{'required': !isFromDateImmediate}">{{'i18n.domain.parker-administration.detail.form.validFrom' | translate}}</label>

      <ejs-datetimepicker id="validFrom"
                          formControlName="validFrom"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm">
      </ejs-datetimepicker>
      <app-error-messages [control]="parkerSubscriptionForm.controls.validFrom"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="d-block">{{'i18n.domain.parker-administration.detail.form.toDateImmediate' | translate}}</label>
      <app-yes-no-group-button id="isToDateImmediate"
                               [(ngModel)]="isToDateImmediate"
                               (change)="handleDateField(isToDateImmediate, parkerSubscriptionForm.controls.validTo, parkerSubscriptionForm.controls.validFrom)"
                               [ngModelOptions]="{standalone: true}"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
             [ngClass]="{'required': !isToDateImmediate}">{{'i18n.domain.parker-administration.detail.form.validTo' | translate}}</label>
      <ejs-datetimepicker id="validTo"
                          formControlName="validTo"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [min]="parkerSubscriptionForm.controls.validFrom.value">
      </ejs-datetimepicker>
      <app-error-messages [control]="parkerSubscriptionForm.controls.validTo"></app-error-messages>
    </div>
  </div>
</form>
